import React from 'react'
import styles from './FooterShell.module.scss'

export const FooterShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <footer className={styles.footer}>
    <div className={styles.inner}>{children}</div>
  </footer>
)

export const FooterColumns: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.columns}>{children}</div>
)

export const FooterColumn: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className={styles.column}>
    <h3 className={styles.columnTitle}>{title}</h3>
    <nav className={styles.columnLinks}>{children}</nav>
  </div>
)

export const FooterDescription: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={styles.description}>{children}</p>
)

export const FooterBottom: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.bottom}>{children}</div>
)
